// extracted by mini-css-extract-plugin
module.exports = {"boxStyle":"InformationBox_boxStyle__2Sufr","linkPlacement":"InformationBox_linkPlacement__nHMSm"};